// Vendor libraries
import { EventEmitter, SimpleChanges, } from '@angular/core';
// Utils / constants
import { ASC } from 'NewAngular/constants/core.constants';
import { getNewSortDirectionCssClasses, getSortColumnAndDirection, initializeSortDirectionCssClasses, sortTableItems, } from 'NewAngular/utils/sort/table-sort';
import { isPublicShareableItem } from 'SharingApp/ts/utils/public-sharing-utils';
import { OPEN_ITEM_MODAL_DEFAULT_SORT_DIRECTIONS } from 'NewAngular/features/components/saved-items/open-item-modal/constants';
import { OpenItemModalAction } from 'NewAngular/features/components/saved-items/open-item-modal/enums/open-item-modal-action.enum';
import { OpenItemModalSortColumn } from 'NewAngular/features/components/saved-items/open-item-modal/enums/open-item-modal-sort-column.enum';
import { PublicSharingState } from 'SharingApp/ts/enums/public-sharing-state.enum';
import { SavedItemType } from 'NewAngular/features/components/saved-items/enums/saved-item-type.enum';
// Services
import { SharingService } from 'SharingApp/ts/services/sharing.service';
// Components
import { OpenItemPreviewModalComponent } from 'NewAngular/features/components/saved-items/open-item-modal/components/open-item-preview-modal/open-item-preview-modal.component';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "SharingApp/ts/services/sharing.service";
import * as i2 from "../../../../modals/confirm-modal/confirm-modal.component";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../directives/icon/icon.directive";
import * as i5 from "../../../../../directives/popovers/tooltip/tooltip.directive";
import * as i6 from "NewAngular/features/components/saved-items/open-item-modal/components/open-item-preview-modal/open-item-preview-modal.component";
import * as i7 from "../../../../../../../../../apps/sharing/static/sharing/ts/pipes/is-shared-with-others.pipe";
const _c0 = ["confirmDeleteModal"];
function OpenItemListComponent_th_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1, "Author");
    i0.ɵɵelementEnd();
} }
function OpenItemListComponent_th_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th", 10);
} }
function OpenItemListComponent_th_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th", 10);
} }
function OpenItemListComponent_th_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th", 10);
} }
function OpenItemListComponent_tbody_15_th_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("tooltipPlacement", "right")("tooltipTitle", item_r3.tooltipMessage)("tooltipHtml", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-team");
} }
function OpenItemListComponent_tbody_15_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, OpenItemListComponent_tbody_15_th_2_span_2_Template, 2, 4, "span", 13);
    i0.ɵɵpipe(3, "isSharedWithOthers");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 2, item_r3));
} }
function OpenItemListComponent_tbody_15_th_3_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("tooltipPlacement", "right")("tooltipTitle", item_r3.tooltipMessage)("tooltipHtml", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-team");
} }
function OpenItemListComponent_tbody_15_th_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th")(1, "label", 16);
    i0.ɵɵelement(2, "input", 17)(3, "span", 18);
    i0.ɵɵelementStart(4, "span", 19);
    i0.ɵɵtext(5);
    i0.ɵɵtemplate(6, OpenItemListComponent_tbody_15_th_3_span_6_Template, 2, 4, "span", 13);
    i0.ɵɵpipe(7, "isSharedWithOthers");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("value", item_r3.id);
    i0.ɵɵproperty("checked", item_r3.id === ctx_r3.selectedItemId);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", item_r3.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 4, item_r3));
} }
function OpenItemListComponent_tbody_15_td_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "td", 20);
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("textContent", item_r3.sharing.owner_name);
} }
function OpenItemListComponent_tbody_15_td_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td")(1, "a", 21);
    i0.ɵɵlistener("click", function OpenItemListComponent_tbody_15_td_8_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r5); const item_r3 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); ctx_r3.openConfirmDeleteModal(item_r3); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r3.canDeleteItem(item_r3));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-delete");
} }
function OpenItemListComponent_tbody_15_td_9_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td")(1, "a", 22);
    i0.ɵɵlistener("click", function OpenItemListComponent_tbody_15_td_9_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r6); const item_r3 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); ctx_r3.editItem(item_r3); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-edit");
} }
function OpenItemListComponent_tbody_15_td_10_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td")(1, "a", 23);
    i0.ɵɵlistener("click", function OpenItemListComponent_tbody_15_td_10_Template_a_click_1_listener($event) { i0.ɵɵrestoreView(_r7); const item_r3 = i0.ɵɵnextContext().$implicit; const ctx_r3 = i0.ɵɵnextContext(); ctx_r3.openSavedAssetPreviewModal(item_r3); return i0.ɵɵresetView($event.stopPropagation()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 24);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", "icon-password-show");
} }
function OpenItemListComponent_tbody_15_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tbody")(1, "tr", 11);
    i0.ɵɵlistener("click", function OpenItemListComponent_tbody_15_Template_tr_click_1_listener() { const item_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r3.selectItem(item_r3)); });
    i0.ɵɵtemplate(2, OpenItemListComponent_tbody_15_th_2_Template, 4, 4, "th", 5)(3, OpenItemListComponent_tbody_15_th_3_Template, 8, 6, "th", 5);
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, OpenItemListComponent_tbody_15_td_7_Template, 1, 1, "td", 12)(8, OpenItemListComponent_tbody_15_td_8_Template, 3, 2, "td", 5)(9, OpenItemListComponent_tbody_15_td_9_Template, 3, 1, "td", 5)(10, OpenItemListComponent_tbody_15_td_10_Template, 3, 1, "td", 5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.showRadioButtons);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.showRadioButtons);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(6, 7, item_r3.modify_date, "M/d/yyyy h:mm a"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r3.isOwner);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.isOwner && !ctx_r3.selectOnly);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.itemTypeInfo ? ctx_r3.itemTypeInfo.isEditable && !ctx_r3.selectOnly : false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.showOpenItemPreview);
} }
/**
 * Open Item List Component
 *
 * Used as a subcomponent of the OpenItemModalComponent. This component displays a list of shareable items
 * and allows a user to select, edit, or delete items in the list.
 *
 * Input Properties:
 *  isOwner: boolean whether the user is the owner of the items in this list
 *  items: ShareableItem[] to be displayed in the list]
 *  itemTypeInfo: ShareableItemTypeInfo object that has the labels and whether the item type can be edited
 *  selectOnly: whether items in the list should be able to be edited/deleted or only selected.
 *  showRadioButtons: displays a radio button for each item in the list.
 *
 * Output Properties:
 *  itemActionHandler: EventEmitter that emits the item and the action type when the user performs an action on an item in the list
 *
 */
export class OpenItemListComponent {
    constructor(sharingService) {
        this.sharingService = sharingService;
        this.isOwner = true;
        this.items = [];
        this.itemTypeInfo = { singularLabel: '', pluralLabel: '', isEditable: false };
        this.selectOnly = false;
        this.showRadioButtons = true;
        this.itemActionHandler = new EventEmitter();
        this.confirmDeleteHeader = '';
        this.confirmDeleteText = '';
        this.formattedItems = [];
        this.itemToDelete = null;
        this.selectedItemId = null;
        this.SORT_COLUMNS = OpenItemModalSortColumn;
        this.sortDirectionCssClasses = initializeSortDirectionCssClasses(Object.values(this.SORT_COLUMNS));
        this.showOpenItemPreview = false;
        this.sortColumnAndDirection = {
            sortColumn: OpenItemModalSortColumn.NAME,
            sortDirection: ASC,
        };
        this.sortDirectionCssClasses.name['th-sort-asc'] = true;
    }
    ngOnInit() {
        this.selectedItemId = null;
        this.confirmDeleteHeader = this.itemTypeInfo ? `Delete ${this.itemTypeInfo.singularLabel}` : '';
        this.confirmDeleteText = this.itemTypeInfo
            ? `Are you sure you want to delete this ${this.itemTypeInfo.singularLabel.toLowerCase()}?`
            : '';
        this.formattedItems = this.formatItems(this.items);
        this.formattedItems = sortTableItems(this.formattedItems, this.sortColumnAndDirection);
    }
    ngOnChanges(changes) {
        if (changes?.items && changes.items.currentValue) {
            this.showOpenItemPreview =
                this.savedItemType === SavedItemType.FUND_CHART || this.savedItemType === SavedItemType.SCATTER_PLOT;
            this.formattedItems = this.formatItems(this.items);
            this.formattedItems = sortTableItems(this.formattedItems, this.sortColumnAndDirection);
        }
    }
    canDeleteItem(item) {
        if (this.selectOnly || !this.isOwner)
            return false;
        return isPublicShareableItem(item) ? item.sharing.public_sharing_state === PublicSharingState.NOT_SHARED : true;
    }
    /**
     * Copies an array of shareable items while adding a tooltip message and the modify_date
     * converted to a date object for to each item.
     * @param items ShareableItem[] to format for display
     * @returns FormattedShareableItem[] used for displaying the list in the template
     */
    formatItems(items) {
        return items.map((item) => {
            return {
                ...item,
                // Store the modify_date as a date object so it can be used for sorting
                modifyDateObj: new Date(item.modify_date),
                tooltipMessage: item.sharing ? this.sharingService.getSharingTooltipMessage(item) : '',
            };
        });
    }
    /**
     * Updates the sort direction and sort column based on the current sort and the column that was clicked.
     * @param newSortColumn
     */
    setSort(newSortColumn) {
        const prevSortColumn = this.sortColumnAndDirection.sortColumn;
        this.sortColumnAndDirection = getSortColumnAndDirection(OPEN_ITEM_MODAL_DEFAULT_SORT_DIRECTIONS, prevSortColumn, newSortColumn, this.sortColumnAndDirection.sortDirection);
        this.sortDirectionCssClasses = getNewSortDirectionCssClasses(this.sortDirectionCssClasses, prevSortColumn, newSortColumn, this.sortColumnAndDirection.sortDirection);
        this.formattedItems = sortTableItems(this.formattedItems, this.sortColumnAndDirection);
    }
    editItem(item) {
        this.itemActionHandler.emit({ item, actionType: OpenItemModalAction.EDIT });
    }
    selectItem(item) {
        this.selectedItemId = item.id;
        this.itemActionHandler.emit({ item, actionType: OpenItemModalAction.SELECT });
    }
    openConfirmDeleteModal(item) {
        this.itemToDelete = item;
        this.confirmDeleteModal.openModal();
    }
    confirmDeleteItem(confirmed) {
        if (confirmed && this.itemToDelete) {
            this.itemActionHandler.emit({ item: this.itemToDelete, actionType: OpenItemModalAction.DELETE });
            this.itemToDelete = null;
        }
    }
    openSavedAssetPreviewModal(item) {
        this.openItemPreviewModalComponent.openModal(item);
    }
    clearSelection() {
        this.selectedItemId = null;
    }
}
OpenItemListComponent.ɵfac = function OpenItemListComponent_Factory(t) { return new (t || OpenItemListComponent)(i0.ɵɵdirectiveInject(i1.SharingService)); };
OpenItemListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OpenItemListComponent, selectors: [["ycn-open-item-list"]], viewQuery: function OpenItemListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(OpenItemPreviewModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmDeleteModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.openItemPreviewModalComponent = _t.first);
    } }, inputs: { isOwner: "isOwner", items: "items", itemTypeInfo: "itemTypeInfo", selectOnly: "selectOnly", showRadioButtons: "showRadioButtons", savedItemType: "savedItemType" }, outputs: { itemActionHandler: "itemActionHandler" }, features: [i0.ɵɵNgOnChangesFeature], decls: 19, vars: 11, consts: [["confirmDeleteModal", ""], [1, "table", "table-hover", "table-sortable", "table-file-open"], ["data-test-id", "name-column-header", 3, "click", "ngClass"], ["href", "javascript:void(0)"], [1, "th-date", 3, "click", "ngClass"], [4, "ngIf"], ["class", "th-control", 4, "ngIf"], [4, "ngFor", "ngForOf"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"], [3, "savedItemType"], [1, "th-control"], [3, "click"], [3, "textContent", 4, "ngIf"], ["ycnTooltip", "", 3, "tooltipPlacement", "tooltipTitle", "tooltipHtml", 4, "ngIf"], ["ycnTooltip", "", 3, "tooltipPlacement", "tooltipTitle", "tooltipHtml"], ["ycnIcon", "", 3, "name"], [1, "custom-control", "custom-radio"], ["type", "radio", "name", "radio-saved-item", 1, "custom-control-input", "pointer-events-none", 3, "value", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [3, "textContent"], ["data-test-id", "delete-saved-item", 1, "btn", "btn-sm", "btn-circle", "btn-transparent", "btn-edit", 3, "click", "hidden"], ["data-test-id", "edit-saved-item", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-edit", 3, "click"], ["data-test-id", "preview-saved-item", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-edit", 3, "click"], ["ycnIcon", "", 1, "icon-password-show", 3, "name"]], template: function OpenItemListComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "table", 1)(1, "thead")(2, "tr")(3, "th", 2);
        i0.ɵɵlistener("click", function OpenItemListComponent_Template_th_click_3_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setSort(ctx.SORT_COLUMNS.NAME)); });
        i0.ɵɵelementStart(4, "a", 3)(5, "span");
        i0.ɵɵtext(6, "Name");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(7, "th", 4);
        i0.ɵɵlistener("click", function OpenItemListComponent_Template_th_click_7_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setSort(ctx.SORT_COLUMNS.MODIFY_DATE_OBJ)); });
        i0.ɵɵelementStart(8, "a", 3)(9, "span");
        i0.ɵɵtext(10, "Date modified");
        i0.ɵɵelementEnd()()();
        i0.ɵɵtemplate(11, OpenItemListComponent_th_11_Template, 2, 0, "th", 5)(12, OpenItemListComponent_th_12_Template, 1, 0, "th", 6)(13, OpenItemListComponent_th_13_Template, 1, 0, "th", 6)(14, OpenItemListComponent_th_14_Template, 1, 0, "th", 6);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(15, OpenItemListComponent_tbody_15_Template, 11, 10, "tbody", 7);
        i0.ɵɵelementStart(16, "ycn-confirm-modal", 8, 0);
        i0.ɵɵlistener("confirmHandler", function OpenItemListComponent_Template_ycn_confirm_modal_confirmHandler_16_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.confirmDeleteItem($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "ycn-open-item-preview-modal", 9);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.sortDirectionCssClasses[ctx.SORT_COLUMNS.NAME]);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", ctx.sortDirectionCssClasses[ctx.SORT_COLUMNS.MODIFY_DATE_OBJ]);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", !ctx.isOwner);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isOwner && !ctx.selectOnly);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.itemTypeInfo ? ctx.itemTypeInfo.isEditable && !ctx.selectOnly : false);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showOpenItemPreview);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngForOf", ctx.formattedItems);
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmButtonText", "Delete")("confirmHeader", ctx.confirmDeleteHeader)("confirmText", ctx.confirmDeleteText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("savedItemType", ctx.savedItemType);
    } }, dependencies: [i2.ConfirmModalComponent, i3.NgClass, i3.NgForOf, i3.NgIf, i4.IconDirective, i5.TooltipDirective, i6.OpenItemPreviewModalComponent, i3.DatePipe, i7.IsSharedWithOthersPipe], encapsulation: 2, changeDetection: 0 });
